import { ErrorHandler, inject, Injectable } from '@angular/core';

import { RuntimeFailureReporter } from './failure-reporter';

/*
 * Handles Angular framework-detected unexpected errors.
 *
 * It emits a minimal classification to the Shell and keeps detailed
 * diagnostics inside the Angular MFE console only.
 */
@Injectable()
export class RuntimeErrorHandler implements ErrorHandler {
  private hasReportedFailure = false;

  private readonly runtimeFailureReporter = inject(RuntimeFailureReporter);

  handleError(error: unknown): void {
    console.error('Angular MFE reported an unexpected runtime failure.', error);

    /*
     * Avoid duplicate events if Angular replays, retries, or reports
     * the same failing rendering work more than once.
     */
    if (this.hasReportedFailure) {
      return;
    }

    this.hasReportedFailure = true;

    this.runtimeFailureReporter.reportUnexpectedRenderFailure();
  }
}
